import { ISelectValues } from "../../../component/ISelectValues";
import { saveAs } from 'file-saver';

const COLOR_AVAILABLE = 'secondary';
const COLOR_ERROR = 'error';
const COLOR_DOWNLOADED = 'success';

export const ID_FILTER_REPORT_TYPE = "type";
export const ID_FILTER_MANDATE_TYPE = "mandateType";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_REPORT_DATE_FROM = "reportDateFrom";
export const ID_FILTER_REPORT_DATE_TO = "reportDateTo";
export const ID_FILTER_COLLECTION_DATE_FROM = "collectionDateFrom";
export const ID_FILTER_COLLECTION_DATE_TO = "collectionDateTo";
export const ID_FILTER_MESSAGE_ID = "messageId";

interface Entry {
    key: string;
    xml: string;
}

export const REPORT_TYPES: ISelectValues[] = [
    {
        value: "SDD_045",
        label: "types.report.SDD045"
    },
    {
        value: "SDD_046",
        label: "types.report.SDD046"
    },
    {
        value: "SDD_355",
        label: "types.report.SDD355"
    }
];

export const MANDATE_TYPES: ISelectValues[] = [
    {
        value: "CORE",
        label: "types.mandate.CORE"
    },
    {
        value: "B2B",
        label: "types.mandate.B2B"
    }
];

export const STATUSES: ISelectValues[] = [
    {
        value: "AVAILABLE",
        label: "types.statuses.AVAILABLE",
        color: COLOR_AVAILABLE,
    },
    {
        value: "DOWNLOADED",
        label: "types.statuses.DOWNLOADED",
        color: COLOR_DOWNLOADED,
    },
    {
        value: "ERROR",
        label: "types.statuses.ERROR",
        color: COLOR_ERROR,
    }
];

export const convertTypology = (type: ISelectValues[], value: string) => {
    const item = type.find((item) => item.value === value);
    return item ? item.label : value;
}

export const getCollectionsSummaryFields = () => {
    return [
        "AVAILABLE",
        "ERROR",
        "DOWNLOADED",
    ];
}

export function downloadZipFile<T extends Entry[]>(entriesData: { entries: T }) {
    const entry = entriesData.entries[0];
    const xmlContent = entry.xml;
    const xmlBlob = new Blob([xmlContent], {type: 'text/xml'});
    saveAs(xmlBlob, `${entry.key}.xml`);
}
